<template>
  <div class="w-100">
    <div 
      class="w-100 mb-3" 
      :class="{
        'border-b-semi-grey-dashed-2 mb-4 pb-4' : product_index+1 < getRestaurantOrder.cart.length || (product_index+1 == getRestaurantOrder.cart.length && product_i+1 < product_list.length)
      }"
      v-for="(product,product_i) in product_list">
      <div class="row no-gutters mb-3">
        <div :class="use_image ? 'col-8 col-xl-9' : 'col-12'">
          <div class="mb-1 body-2-1">{{product.name}}</div>
          <div class="w-100 d-flex">
            <p class="mb-0 lh-1 align-items-center text-14 font-lato">{{ $formatCurrency(product.final_price) }}</p>
            <p class="mb-0 lh-1 align-items-center ml-2 text-12 font-lato text-semi-light text-line-through" style="margin-top: 1px;" v-if="product.is_decrease_promo">{{ $formatCurrency(product.promotion_price) }}</p>
          </div>
          <div class="w-100 d-flex mt-2" v-if="product.notes != ''">
            <p class="mb-0 body-3-1 mr-2">Notes : </p>
            <p class="mb-0 body-3">{{ product.notes }}</p>
          </div>
        </div>
        <div class="col-4 col-xl-3" v-if="use_image">
          <div class="w-100 position-relative" style="height: 60px;">
            <img :src="data.product.data.image_url" class="img-fit radius-6" />
            
            <!-- DELIVERY -->
            <template v-if="getMerchant.use_delivery">
              <div :id="`delivery-product-${product.id}`" class="bg-white p-1 rounded body-3-1 position-absolute mb-0" style="right: 4px;top: 4px;">
                <img v-if="product.use_delivery" src="../../assets/img/icon/fast-delivery.png" width="20">
                <img v-else src="../../assets/img/icon/cutlery.png" width="20">
              </div>
              <b-tooltip :target="`delivery-product-${product.id}`" placement="top" :title="product.use_delivery ? 'Available for delivery' : 'Dine in only'">
              </b-tooltip>
            </template>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-8 col-xl-9"> 
          <button class="g-btn g-btn-secondary-outline g-btn-sm" @click="toggleNote(product)">Add Note</button>
        </div>
        <div class="col-4 col-xl-3">
          <div class="d-flex justify-content-between">
            <div class="align-self-center pos-order-qty bg-green" @click="changeQtyProduct('minus',product)">
              <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.71429H0V0H12V1.71429Z" fill="white"/>
              </svg>
            </div>
            <div class="align-self-center">
              <p class="mb-0 font-lato text-14">{{ product.qty  }}</p>
            </div>
            <div class="align-self-center pos-order-qty bg-green" @click="changeQtyProduct('plus',product)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup-detail
      direction="bottom" 
      :show="note.show"
      :use_max_size="true"
      wrapper_size="mobile"
      :use_footer="true"
      @close="toggleNote">
      <template v-slot:body>
        <div class="w-100 border-bottom p-3 position-relative">
          <div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
            <img :alt="data.product.data.name" :src="data.product.data.image_url" class="img-fit radius-6">
          </div>
          <div class="d-inline-block align-middle w-75">
            <p class="mb-0 body-1-2">{{note.selected_data.name}}</p>
            <div class="w-100"> 
              <p 
                v-if="note.selected_data.is_decrease_promo" 
                class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
                {{$formatCurrency(note.selected_data.promotion_price)}}
              </p>
              <p 
                class="mb-0 body-2-4 text-orange d-inline-block align-middle"
                :class="{
                  'd-inline-block align-middle': note.selected_data.is_decrease_promo
                }"
                >
                {{$formatCurrency(note.selected_data.final_price)}}
              </p>
            </div>
          </div>
          <div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleNote()">
            <img alt="close-icon" src="../../assets/img/icon/close.png" width="14" />
          </div>
        </div>
        <div class="p-3">
          <span class="body-3 mb-1 d-block w-100">Notes</span>
          <div class="w-100 position-relative">
            <textarea
              ref="note_form"
              rows="3"
              placeholder="Add some special request"
              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
              v-model="note.form">
            </textarea>
            <i class="simple-icon-notebook text-semi-dark text-16 position-absolute icon-form-position"></i>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <state-button
            :click="submitNote" 
            size="lg"
            variant="primary"
            block >
            Save Note
          </state-button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import PopupInputNote from '@/components/hotel/concierge/general/PopupInputNote'

  export default{
    components:{
      PopupInputNote
    },
  	props:{
      data:{
        type: Object,
        default: () => {}
      },
      use_image:{
        type: Boolean,
        default: false
      },
      product_index:{
        type: Number,
        default: 0
      }
    },
    data(){
      return{
        note:{
          show: false,
          form: '',
          selected_data: {},
          variant_id: ''
        },

        is_note: false,
        note_title: '',
        note_vuex: {
          product_id: '',
          variant_id: '',
          notes: ''
        }
      }
    },
    computed:{
      ...mapGetters(['getRestaurantOrder', 'getRestaurantDelivery', 'getMerchant']),
      is_variant(){
        return this.data.variant.length == 0 ? false : true
      },
      product_list(){
        let return_data = []
        if(this.is_variant){
          this.data.variant.forEach(variant=>{
            let base_price = variant.data.price
            let data = {
              id: variant.data.id,
              original : variant,
              name: `${variant.data.name} - ${this.data.product.data.name}`,
              use_delivery: variant.data.allow_delivery,
              is_decrease_promo: this.calcIsDecreasePromo(base_price),
              promotion_price: this.calPromotionPrice(base_price),
              final_price: this.$calculateFinalPriceConcierge(base_price),
              qty: variant.qty,
              notes: variant.notes  
            }
            return_data.push(data)
          })
        }else{
          let base_price = this.data.product.data.price
          let data = {
            id: this.data.product.data.id,
            original : this.data,
            name: this.data.product.data.name,
            use_delivery: this.data.product.data.allow_delivery,
            is_decrease_promo: this.calcIsDecreasePromo(base_price),
            promotion_price: this.calPromotionPrice(base_price),
            final_price: this.$calculateFinalPriceConcierge(base_price),
            qty: this.data.qty,
            notes: this.data.notes
          }
          
          return_data.push(data)
        }

        return return_data
      }
    },
  	methods:{
  		...mapMutations(['setRestaurantOrder','removeRestaurantOrder','setRestaurantOrderNote']),
      changeQtyProduct(type,product_detail=null){
        let params = {
            product: this.data.product.data,
            variant: this.is_variant ? product_detail.original.data : {},
            qty: product_detail.qty
          }
          if(params.qty == 1 && type == 'minus'){
            this.removeRestaurantOrder(params)
          }else{
            if(type == 'minus'){
              params.qty--
            }else{
              params.qty++
            }
            this.setRestaurantOrder(params)
          }
      },
      toggleNote(product){
        this.note.show = !this.note.show
        if(this.note.show){
          this.note.form = product.notes
          this.note.selected_data = product
          this.note.variant_id = this.is_variant ? product.original.data.id : ''
          setTimeout(() => {
            this.$refs.note_form.focus()
          }, 100);
        }else{
          this.note.form = ''
          this.note.selected_data = {}
          this.note.variant_id = ''
        }
      },
      submitNote(){
        return new Promise((success,fail)=>{
          let params = {
            product_id: this.data.product.data.id,
            variant_id: this.note.variant_id,
            notes: this.note.form
          }
          setTimeout(()=>{
            this.setRestaurantOrderNote(params)
            this.toggleNote()
            success()
          },300)
        })
      },
      calPromotionPrice(price){
        if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell
        }
      },
      calcIsDecreasePromo(price){
        if(price.promotion_amount == 0){
          return false
        }else{
          return price.promotion_type == 'INCREASE' ? false : true
        }
      }
  	}
  }
</script>
<style>
  .input-custom-padding{
    padding: 8px 8px 8px 42px;
  }
  .icon-form-position{
    top: 11px;
    left: 12px;
  }
  .pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuCart.vue